import React from 'react';
import { Colors, Images } from 'utils';
import { MinLoader } from '../loader';
import { buttonsStyle } from './styles';

export const EditWithIcon = ({ handleClick, styles, stylesIcon, load, icon, type = 'button', disabled, id, innerText }) => {
  const classes = buttonsStyle();
  return (
    <button
      id={id ? id : 'edit-btn'}
      disabled={disabled}
      type={type}
      style={{ ...styles }}
      className={classes.editBtnBox}
      onClick={handleClick}
    >
      <div className={classes.editBtnBoxImgSvg}>
        {load ?
          <MinLoader margin={'0'} color={Colors.ThemeBlue} position={'relative'} />
          :
          <img src={icon ? icon : Images.editNew} alt='edit' style={{ ...stylesIcon }} />
        }
      </div>
      {
        innerText &&
        <p>{innerText}</p>
      }
    </button>
  );
};